import { Scene } from 'babylonjs';
import { applyLighting } from './Lighting.js';
import CameraController from './Controller.js';
import { loadAndApplyPhysics } from './Render.js';

export const createScene = async function (canvas, engine) {
  const scene = new Scene(engine);

  // Appliquer l'éclairage avant de charger les assets
  applyLighting(scene);

  // Création du contrôleur de caméra et configuration de la caméra
  const controller = new CameraController(scene, canvas);
  controller.createCamera();

  // Récupération du collider attaché à la caméra
  const cameraCollider = controller.getCameraCollider();

  // Liste des assets à charger
  const assets = ["GTMR_bake", "yacht_bake", "mobilier_bake", "lunettes", "interior_bake", "colliders", "triggers"];

  // Charger tous les assets en parallèle
  const assetPromises = assets.map((asset) => loadAndApplyPhysics(asset, scene, cameraCollider));

  // Attendre que tous les assets soient chargés
  await Promise.all(assetPromises);

  // Retour d'un objet contenant la scène et le contrôleur de la caméra
  return { scene, controller };
};